import { defineAsyncComponent, defineComponent, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAvailableCurrencyListStore } from '@/store/dictionary/available-currency-list.store';
import { useAvailableCurrencyCodeListStore } from '@/store/currency/available-currency-code-list.store';
import { useCurrencyListStore } from '@/store/dictionary/currency-list.store';
import { useTwoFactorStore } from '@/store/two-factor-dialog.store';
import { usePermissionsStore } from '@/store/permissions.store';
import { CurrencyItem } from '@/models/dictionary/currency-list.model';
import { useEnvStore } from '@/store/env.store';

export default defineComponent({
  name: 'CurrencyPage',
  components: {
    TwoFactorAuthDialog: defineAsyncComponent(
      () => import('@/components/two-factor-auth-dialog/two-factor-auth-dialog.vue'),
    ),
  },
  setup() {
    const { WL_SLUG, WHITELABEL_ID } = storeToRefs(useEnvStore());

    const { getAvailableCurrencyList } = useAvailableCurrencyListStore();

    const availableCurrencyCodeListStore = useAvailableCurrencyCodeListStore();
    const {
      setAvailableCurrencyCodeList,
      updateAvailableCurrencyCodeList,
    } = availableCurrencyCodeListStore;
    const { availableCurrencyCodeList } = storeToRefs(availableCurrencyCodeListStore);

    const currencyListStore = useCurrencyListStore();
    const { getCurrencyList, setCurrencyListLoading } = currencyListStore;
    const { fullCurrencyList, isCurrencyListLoading } = storeToRefs(currencyListStore);

    const { openTwoFactorDialog } = useTwoFactorStore();

    const {
      isGetCurrencyListAllowed,
      isUpdateCurrencyListAllowed,
    } = storeToRefs(usePermissionsStore());

    const updateAvailableCurrencyCodeListAction = (code: string): Promise<void> => {
      return updateAvailableCurrencyCodeList({ code, whitelabelId: WHITELABEL_ID.value });
    };

    onMounted(async () => {
      if (!isGetCurrencyListAllowed.value) {
        return;
      }

      setCurrencyListLoading(true);

      const currencyList = await getAvailableCurrencyList(WHITELABEL_ID.value);
      setAvailableCurrencyCodeList(currencyList.map((currency: CurrencyItem) => currency.code));

      getCurrencyList({ isFetchFullList: true, wlSlug: WL_SLUG.value })
        .finally(() => setCurrencyListLoading(false));
    });

    onUnmounted(() => {
      setAvailableCurrencyCodeList([]);
    });

    return {
      fullCurrencyList,
      availableCurrencyCodeList,
      isUpdateCurrencyListAllowed,
      openTwoFactorDialog,
      isCurrencyListLoading,
      updateAvailableCurrencyCodeListAction,
    };
  },
});
